export function loadScript(url) {
  return new Promise((resolve, reject) => {
    const js = document.createElement('script');
    js.type = 'text/javascript';
    js.async = 1;
    document.body.appendChild(js);
    js.onload = () => {
      resolve();
    };
    js.onerror = () => {
      js.remove();
      reject();
    };
    js.src = url;
  });
}
